import { ReactNode } from 'react'
import Styles from './RequestCard.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  children: ReactNode
}

export const Message = ({ children }: Props) => (
  <div className={Styles.message}>
    <Text color="var(--dark-80)" variant="secondary">
      {children}
    </Text>
  </div>
)
